const de = {
  ADMINPANEL_CONTACT: "Kontaktreiter",
  ADMINPANEL_COUNTRYFIX: "Länderkorrektur",
  ADMINPANEL_EDIT: "@it Funktionen",
  ADMINPANEL_RIGHTS: "Berechtigungen",
  ADMINPANEL_TITLE: "Verwaltung",
  CAMPAIGN_ACTION_DATE: "Datum",
  CAMPAIGN_ACTION_DELETEFILE_ALERT: "Möchten Sie den Dateianhang '{0}' wirklich löschen?",
  CAMPAIGN_ACTION_DELETEFILE_TT: "Dateianhang löschen",
  CAMPAIGN_ACTION_DESC: "Beschreibung",
  CAMPAIGN_ACTION_DOWNLOADFILE_TT: "Datei herunterladen",
  CAMPAIGN_ACTION_FILES_TITLE: "Dateianhänge",
  CAMPAIGN_ACTION_NEW_ATTACHMENT: "Neuer Anhang...",
  CAMPAIGN_ACTION_PRINT_TITLE: "Print Mailing",
  CAMPAIGN_ACTION_TITLE: "Kampagnen Event",
  CAMPAIGN_CHART_WARNING_ALLINVISIBLE: "Aktuell sind keine Kampagnen in der Zeitleiste sichtbar.\nKampagnen mit einem Enddatum, das mehr als 30 Tage zurückliegt, werden standardmäßig nicht angezeigt.\nMithilfe des Buttons 'Kampagnen auswählen' links unten können Sie beliebige Kampagnen zur Zeitleiste hinzufügen.",
  CAMPAIGN_CHART_WARNING_NOCAMPAIGNS: "Es sind keine Kampagnen in der Datenbank gespeichert.",
  CAMPAIGN_ENDDATE: "Enddatum: {0}",
  CAMPAIGN_FIRST_DISPATCH: "erstes Versanddatum",
  CAMPAIGN_GUI_BT_OPTIONS: "Kampagnen auswählen",
  CAMPAIGN_GUI_BT_POPUP_APPLY: "Ansicht aktualisieren",
  CAMPAIGN_GUI_BT_POPUP_TEXT: "Wählen Sie die Kampagnen aus, die im Dashboard angezeigt werden sollen. ",
  CAMPAIGN_GUI_BT_REFRESH: "Ansicht aktualisieren",
  CAMPAIGN_GUI_SLIDER_3MONTHS: "3 Monate",
  CAMPAIGN_GUI_SLIDER_DESC: "Zoomfaktor",
  CAMPAIGN_GUI_SLIDER_HALFYEAR: "6 Monate",
  CAMPAIGN_GUI_SLIDER_MONTH: "1 Monat",
  CAMPAIGN_GUI_SLIDER_YEAR: "1 Jahr",
  CAMPAIGN_GUI_TOOLTIP_DATE: "Datum:",
  CAMPAIGN_GUI_TOOLTIP_NAME: "Name:",
  CAMPAIGN_GUI_TOOLTIP_NUM_MAIL: "Anzahl Mailings:",
  CAMPAIGN_GUI_TOOLTIP_NUM_PRINT: "Anzahl Print Mailings:",
  CAMPAIGN_GUI_TOOLTIP_OWNER: "Eigentümer:",
  CAMPAIGN_GUI_TOOLTIP_PERIOD: "Zeitraum:",
  CAMPAIGN_GUI_TOOLTIP_STATUS: "Status:",
  CAMPAIGN_INVALID_PERIOD: "Der gewählte Kampagnen-Zeitraum ist ungültig.",
  CAMPAIGN_INVALID_PERIOD_TITLE: "Ungültiger Zeitraum",
  CAMPAIGN_LAST_DISPATCH: "letztes Versanddatum",
  CAMPAIGN_MISSING_DATES: "Start- und Enddatum müssen ausgefüllt werden.",
  CAMPAIGN_NAME: "Name",
  CAMPAIGN_NUM_MAILINGS: "Anzahl Mailings",
  CAMPAIGN_NUM_PRINTMAILINGS: "Anzahl Print Mailings",
  CAMPAIGN_RANGE: "Startdatum - Enddatum",
  CAMPAIGN_STARTDATE: "Startdatum: {0}",
  CAMPAIGN_SWAPPED_DATES: "Das Enddatum liegt vor dem Startdatum.",
  CAMPAIGN_TITLE: "Kampagne",
  CAMPAING_DISPATCH_OUTSIDE_WARN: "Diese Kampagne enthält Mailings mit einem Versanddatum außerhalb der Kampagnen-Laufzeit.",
  CONTACT: "Kontakt",
  CONTACT_ACCOUNT_NAME: "Benutzerkonto",
  CONTACT_ADDRESS: "Anschrift",
  CONTACT_ADDRESS_FROM_COMPANY: "von Firma übernehmen",
  CONTACT_BROWSE_MARKED: "markiert",
  CONTACT_BROWSE_OF: "{0} von {1}",
  CONTACT_CATEGORIES: "Kategorien",
  CONTACT_CLEAR_DATE_FF_TT: "Datum entfernen",
  CONTACT_COMPANY_SHOW_EMPLOYEES: "Alle Mitarbeiter dieser Firma als Suchergebnis anzeigen.",
  CONTACT_COPY_CLIPBOARD_TT: "Visitenkarte in Zwischenablage kopieren",
  CONTACT_CLIPBOARD_OK_SB: "Kopiert",
  CONTACT_CLIPBOARD_ERROR_SB: "Kopieren nicht möglich",
  CONTACT_CORPORATE: "Unternehmen",
  CONTACT_COUNTRY_AUTOCORRECT_TT: "Das Land wurde automatisch korrigiert. Speichern Sie den Kontakt, um die Korrektur zu übernehmen.",
  CONTACT_CREATED: "Erstellt am",
  CONTACT_DELETE_ACCOUNTS: "Löschen inklusive Benutzerkonto",
  CONTACT_DELETE_ALERT: "Wollen Sie diesen Kontakt wirklich unwiderruflich aus der Datenbank löschen?",
  CONTACT_DROPPED_FROM_RESULT: "Aufgrund von Änderungen ist dieser Kontakt nicht mehr Teil des Suchergebnisses.",
  CONTACT_DUPLICATE: "Duplizieren",
  CONTACT_DUPLICATION_PROCESS: "Ein Duplikat des Kontaktes wurde vorbereitet. Sobald Sie auf Speichern drücken, wird ein neuer Datensatz in der Datenbank angelegt. Vor dem Speichern sollten Sie die Stammdaten überarbeiten und auch die Kategorien und Freifelder auf Richtigkeit prüfen.",
  CONTACT_FREE_FIELDS: "Freifelder",
  CONTACT_GENDER_FEMALE: "Frau",
  CONTACT_GENDER_MALE: "Herr",
  CONTACT_GENDER_UNKNOWN: "[unbekannt]",
  CONTACT_IMPORT_VCARD: "vCard Import",
  CONTACT_INVALID_COUNTRY_TT: "Es ist ein unbekannter Wert als Land gespeichert. Bitte wählen Sie ein gültiges Land aus.",
  CONTACT_MAIN_DATA: "Stammdaten",
  CONTACT_MODIFIED: "Letzte Änderung am",
  CONTACT_NEWSLETTER_BOUNCED: "E-Mail konnte nicht zugestellt werden (Bounce)",
  CONTACT_NOTES: "Bemerkungen",
  CONTACT_NOTES_CLIPBOARD_OK_SB: "Notizen kopiert",
  CONTACT_NOTES_CLIPBOARD_ERROR_SB: "Notizen kopieren nicht möglich",
  CONTACT_NOTES_MERGED_SUIDS: "SUID aus Merge",
  CONTACT_NOTES_RESUB_LABEL: "Wiedervorlage für {0}",
  CONTACT_NOTES_RESUB_POPUP_BTN_CHANGE: "Datum übernehmen",
  CONTACT_NOTES_RESUB_POPUP_BTN_REMOVE: "Wiedervorlage entfernen",
  CONTACT_NOTES_RESUB_POPUP_DATE: "Datum",
  CONTACT_NOTES_RESUB_POPUP_DONE: "erledigt",
  CONTACT_NOTES_RESUB_POPUP_DONE_TT: "Eine als erledigt markierte Wiedervorlage erscheint nicht in der Liste auf dem Dashboard und wird nicht in der Reminder-E-Mail berücksichtigt.",
  CONTACT_NOTES_RESUB_POPUP_FOR: "Wiedervorlage für",
  CONTACT_NOTES_RESUB_POPUP_TEXT: "Kommentar",
  CONTACT_NOTES_RESUB_POPUP_TITLE: "Datum für Wiedervorlage",
  CONTACT_NOTES_RESUB_POPUP_WARNING: "Das ausgewählte Datum liegt in der Vergangenheit",
  CONTACT_NOTES_RESUB_POPUP_WARNING_TITLE: "Warnung",
  CONTACT_NOTES_SAVE_FIRST: "Um Bemerkungen anlegen zu können, muss der Kontakt zunächst gespeichert werden.",
  CONTACT_NOTE_DELETE_ALERT: "Möchten Sie diese Bemerkung wirklich löschen?",
  CONTACT_NOTE_DELETE_TT: "Eintrag löschen",
  CONTACT_NOTE_EDIT_TT: "Eintrag bearbeiten",
  CONTACT_NOTE_MODIFIED_ON: "geändert am",
  CONTACT_NOTE_NEW: "Neue Bemerkung",
  CONTACT_NOTE_NEW_RESUB: "Neue Wiedervorlage",
  CONTACT_NOTE_RESUB_DATE: "Termin: {0}",
  CONTACT_NOTE_RESUB_DONE: "erledigt?",
  CONTACT_NOTE_RESUB_DONE_TT: "Wiedervorlage als erledigt markieren, um Reminder zu deaktivieren.",
  CONTACT_NOTE_SAVE_TT: "Bemerkung speichern",
  CONTACT_NOTE_TO_CLIPBOARD_TT: "Bemerkungen in die Zwischenablage kopieren",
  CONTACT_NOTE_UNDO_TT: "Bearbeiten abbrechen",
  CONTACT_NOT_FOUND_ALERT: "Ein Kontakt konnte nicht geladen werden. Evtl. wurde er von einem anderen Benutzer zwischenzeitlich gelöscht.",
  CONTACT_NOT_FOUND_TITLE: "Fehlender Datensatz",
  CONTACT_PHOTO_DELETE_ALERT: "Möchten Sie das Kontaktfoto wirklich endgültig löschen?",
  CONTACT_PHOTO_DELETE_BTN: "Bild löschen",
  CONTACT_PHOTO_DOESNT_EXIST: "Kein Kontaktfoto vorhanden",
  CONTACT_PHOTO_SAVE_FIRST: "Ihre Änderungen müssen gespeichert werden, bevor das Kontaktfoto geöffnet wird.",
  CONTACT_PHOTO_UPLOAD_BTN: "Bild ersetzen",
  CONTACT_PHOTO_VIEW_TITLE: "Kontaktfoto",
  CONTACT_RESUBMISSIONS_ON: "Wiedervorlagen aktiv!",
  CONTACT_SEND_EMAIL_TT: "E-Mail an Kontakt senden",
  CONTACT_SHOW_TAB_TT: "in Reiter '{0}' anzeigen",
  CONTACT_STANDARD_FIELDS: "Stammdaten",
  COUNTRYFIX_BTN_FIX_TT: "Land korrigieren",
  COUNTRYFIX_BTN_SHOW_TT: "Kontakte anzeigen",
  COUNTRYFIX_COL_COUNT: "Anzahl",
  COUNTRYFIX_COL_TEXT: "Fehlerhaftes Land",
  COUNTRYFIX_DIALOG_APPLY: "Anwenden",
  COUNTRYFIX_DIALOG_CHOOSE_PROMPT: "Wählen Sie ein Land...",
  COUNTRYFIX_DIALOG_HEADER: "Land ersetzen",
  COUNTRYFIX_DIALOG_REPLACEBY: "ersetzen durch",
  COUNTRYFIX_DIALOG_WARNING: "Anzahl der betroffenen Kontakte: {0}",
  COUNTRYFIX_TITLE: "Länderkorrektur",
  CUSTOMTABCONFIGPANEL_ALERT_TEXT: "Das von Ihnen ausgewählte Feld wird bereits auf dem Reiter '{0}' verwendet. Möchten Sie es von diesem Reiter entfernen und hier einfügen?",
  CUSTOMTABCONFIGPANEL_ALERT_TITLE: "Feld verschieben",
  CUSTOMTABCONFIGPANEL_BTCHANGES: "Reiterkonfiguration speichern",
  CUSTOMTABCONFIGPANEL_BTLANGUAGES: "Andere Sprachen...",
  CUSTOMTABCONFIGPANEL_POPUP_HEAD: "Reitertitel in anderen Sprachen",
  CUSTOMTABCONFIGPANEL_POPUP_LANGUAGE: "Sprache",
  CUSTOMTABCONFIGPANEL_POPUP_TITLE: "Name",
  CUSTOMTABCONFIGPANEL_TAB_CATEGORIES_TEXT: "Diese Felder werden auf dem Reiter 'Kategorien' eines Kontaktes angezeigt:",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_BTDELETE: "Reiter löschen",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_LABEL: "*Neuer Reiter",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_TEXT: "Befüllen Sie nun die Spalte mit Elementen aus der linken Liste",
  CUSTOMTABCONFIGPANEL_TAB_CUSTOMITEM_TILABEL: "Bitte geben Sie den Namen des Reiters ein:",
  CUSTOMTABCONFIGPANEL_TAB_FREEFIELDS_TEXT: "Diese Felder werden auf dem Reiter 'Freifelder' eines Kontaktes angezeigt:",
  CUSTOMTABCONFIGPANEL_TITLE: "Kontaktreiter Konfiguration",
  CUSTOMTABCONFIGPANEL_TOGGLE_ALL: "Alle Felder",
  CUSTOMTABCONFIGPANEL_TOGGLE_UNUSED: "Nicht verwendete",
  DASHBOARD_BT_CAMPAIGNS: "Kampagnen",
  DASHBOARD_BT_MAILINGS: "Mailings",
  DASHBOARD_BT_MYDASH: "Mein Dashboard",
  DASHBOARD_BT_REPORTING: "Reporting",
  DB_ACCOUNTID: "Account ID",
  DB_ACCOUNTNAME: "Account Name",
  DB_ARCHIVED: "Archivierte Adresse",
  DB_BOUNCED: "E-Mail nicht zustellbar",
  DB_CITY: "Stadt",
  DB_CITY2: "Stadt 2",
  DB_REGION: "Region",
  DB_COMPANY: "Firma",
  DB_COMPANY2: "Firma 2",
  DB_COMPANY3: "Firma 3",
  DB_COMPANY4: "Firma 4",
  DB_COMPANYEXT: "Firmenzusatz",
  DB_COUNTRY: "Land",
  DB_CREATED: "Erstellungsdatum",
  DB_CREATEDLABEL: "Erstellungsdatum",
  DB_DIVISION: "Abteilung",
  DB_EMAIL: "E-Mail",
  DB_FAX: "Fax",
  DB_FIRSTNAME: "Vorname",
  DB_GENDER: "Anrede",
  DB_GENDERLABEL: "Anrede",
  DB_HOMEPAGE: "Homepage",
  DB_ID: "ID",
  DB_LASTNAME: "Nachname",
  DB_MOBILE: "Mobil",
  DB_MODIFICATIONDATE: "Änderungsdatum",
  DB_MODIFIEDLABEL: "Änderungsdatum",
  DB_NEWSLETTER: "E-Mail aktiviert",
  DB_PHONE: "Telefon",
  DB_POBOX: "Postfach",
  DB_POSITION: "Position",
  DB_REGID: "RegID",
  DB_SECONDNAME: "2. Vorname",
  DB_STATE: "Bundesland",
  DB_STREET: "Straße",
  DB_STREET2: "Straße 2",
  DB_STREET3: "Straße 3",
  DB_STREET4: "Straße 4",
  DB_HOUSE_NO: "Hausnummer",
  DB_SUID: "SUID",
  DB_TITLE: "Titel",
  DB_TITLE2: "Titel 2",
  DB_ZIPPOBOX: "PLZ (Postf.)",
  DB_ZIPSTREET: "PLZ (Straße)",
  DIALOG_RENAME_NAME_LABEL: "Name",
  EASYSELECT_CATEGORY_ADD_ERROR_CONTENT: "Eine Kategorie mit diesem Namen ist bereits vorhanden.",
  EASYSELECT_CATEGORY_NEW_ENTRY_NOTE: "neue Kategorie",
  EASYSELECT_CATEGORY_PANEL_ADD_BT: "Kategorie hinzufügen",
  EASYSELECT_CATEGORY_PANEL_ADD_PROMPT: "Kategorie",
  EASYSELECT_CATEGORY_PANEL_CB_TT: "Die neue Kategorie direkt auswählen",
  EASYSELECT_CATEGORY_PANEL_TITLE: "Neue Kategorie hinzufügen",
  EASYSELECT_CATEGORY_PANEL_TT_PROMPT: "Beschreibung",
  EASYSELECT_CATEGORY_PANEL_TT_TT: "Hier können Sie eine kurze Erklärung zur Kategorie geben, die dann als Hinweis-Icon erscheint.",
  EASYSELECT_CATEGORY_UNSAVED_CHANGES_CONTENT_MANY: "Sie haben {0} neue Kategorien hinzugefügt. Möchten Sie diese Änderung jetzt speichern?",
  EASYSELECT_CATEGORY_UNSAVED_CHANGES_CONTENT_ONE: "Sie haben eine neue Kategorie hinzugefügt. Möchten Sie diese Änderung jetzt speichern?",
  EASYSELECT_CATEGORY_UNSAVED_CHANGES_TITLE: "Neue Kategorien",
  EASYSELECT_CB_OPEN_BUTTON_TT: "Auswahl in einem extra Fenster öffnen",
  EASYSELECT_DEFAULT_TITLE: "Bitte treffen Sie eine Auswahl",
  EASYSELECT_FILTER_FAIR_CHECK: "Messe-Präfix",
  EASYSELECT_FILTER_FAIR_CHECK_TT: "Selektieren Sie diese Checkbox, um den Messe-Präfix-Filter anzuwenden.",
  EASYSELECT_FILTER_FAIR_TT: "Anzeige der Kategoriewerte nach Messe-Präfix filtern (z.B. fair2014).",
  EASYSELECT_FILTER_TEXT_TT: "Anzeige der Kategoriewerte nach beliebigem Text filtern.",
  EASYSELECT_PROMPT: "Klicken zum Auswählen...",
  EASYSELECT_SELECT_ALL: "Alle auswählen",
  EASYSELECT_SELECT_NONE: "Keine auswählen",
  ERROR_CLOSE: "Schließen",
  ERROR_COPY_CLIPBOARD_TT: "Fehlermeldung in Zwischenablage kopieren",
  ERROR_DETAILS: "Details...",
  ERROR_DUPLICATE_CAMPAIGN_NAME: "Die Kampagne konnte nicht gespeichert werden, weil es bereits eine Kampagne mit diesem Namen gibt.",
  ERROR_HEADING: "Fehler",
  ERROR_IMPORT_VCARD: "Die vCard konnte nicht importiert werden.",
  ERROR_INTERNAL: "Es ist ein unerwarteter Fehler in der Oberfläche aufgetreten. Falls das CRM nicht mehr korrekt reagiert, aktualisieren Sie bitte das Browserfenster.",
  ERROR_INVALID_RESPONSE: "Es ist ein Fehler auf Serverseite aufgetreten. Die erhaltene Antwort ist ungültig.",
  ERROR_SAVE_CONTACT: "Der Kontakt konnte nicht gespeichert werden. Evtl. wurde er von einem anderen Benutzer zwischenzeitlich gelöscht.",
  ERROR_SERVER_FAILED: "Die Kommunikation mit dem Server ist fehlgeschlagen. Sollte dieses Problem bestehen bleiben, wenden Sie sich bitte an ihren System-Administrator.",
  ERROR_UNEXPECTED_RESPONSE: "Es ist ein Fehler auf Serverseite aufgetreten. Die erhaltene Antwort hat einen unbekannten Status.",
  ERROR_UNSPECIFIED: "Unbekannter Fehler",
  EXPORT_CATEGORY_VALUES: "...innerhalb einer Spalte",
  EXPORT_COLUMNS: "...zwischen Spalten",
  EXPORT_CONFIGURATION: "Export Konfiguration",
  EXPORT_DELETE_ALERT: "Wollen Sie die Export-Konfiguration '{0}' wirklich löschen?",
  EXPORT_DELETE_CONFIG: "Löschen",
  EXPORT_DRAG_HERE: "Bitte ziehen Sie die gewünschten Felder hier hinein.",
  EXPORT_ENCODING: "Zeichensatz",
  EXPORT_EXPERT_SETTINGS: "Erweiterte Einstellungen",
  EXPORT_FIELD_COUNTRY_ID: "Länderkennung",
  EXPORT_FIELD_COUNTRY_NAME: "Land",
  EXPORT_FORMAT: "Exportformat",
  EXPORT_HINT_ALL_INCLUDED: "Alle Felder wurden ausgewählt",
  EXPORT_HINT_INCLUDE: "Mindestens ein Feld zum Exportieren einbeziehen",
  EXPORT_INVALID_ALERT_TITLE: "Ungültiger Export",
  EXPORT_INVALID_NOFIELDS: "Dies ist keine gültige Konfiguration, da keine Felder ausgewählt wurden.",
  EXPORT_INVALID_SEPARATORS: "Dies ist keine gültige Konfiguration. Bitte überprüfen Sie die Trennzeichen in 'Erweiterte Einstellungen'.",
  EXPORT_NEW_CONFIG: "[Neue Konfiguration]",
  EXPORT_NUM_SELECTED_FIELDS: "Ausgewählt: {0}",
  EXPORT_NUMBER_INCLUDED: "Anzahl der enthaltenen Kontakte: {0}",
  EXPORT_RENAME_CONFIG: "Export-Konfiguration umbenennen",
  EXPORT_RENAME_HEADER: "Export-Konfiguration umbenennen",
  EXPORT_RUN_CSV: "Exportieren als CSV",
  EXPORT_RUN_EXCEL: "Exportieren als Excel",
  EXPORT_SAVEAS_HEADER: "Export-Konfiguration speichern",
  EXPORT_SAVE_CONFIG: "Export-Konfiguration speichern",
  EXPORT_SELECT_CONFIG: "Konfiguration auswählen",
  EXPORT_SEPARATOR_COMMA: "Komma",
  EXPORT_SEPARATOR_COLUMNS: "[separate Spalten]",
  EXPORT_SEPARATOR_FOR: "Trennzeichen",
  EXPORT_SEPARATOR_BETWEEN: "Trennzeichen zwischen den Spalten",
  EXPORT_SEPARATOR_WITHIN: "Trennzeichen innerhalb von Spalten",
  EXPORT_SEPARATOR_FREE_CHAR: "[benutzerdefiniert...]",
  EXPORT_SEPARATOR_FREE_CHAR_LABEL: "benutzerdefiniert",
  EXPORT_SEPARATOR_SEMICOLON: "Semikolon",
  EXPORT_SEPARATOR_TAB: "Tabulator",
  EXTSEARCH_ADD_CONTACT: "Kontakt hinzufügen",
  EXTSEARCH_ADD_SEARCH_BLOCK: "Suchblock hinzufügen",
  EXTSEARCH_CONFIG: "Suchkonfiguration",
  EXTSEARCH_CONFIG_GROUP: "Kontakte",
  EXTSEARCH_DATEINPUT_DAY: "Tag",
  EXTSEARCH_DATEINPUT_HOUR: "Stunde",
  EXTSEARCH_DATEINPUT_MINUTE: "Minute",
  EXTSEARCH_DATEINPUT_MONTH: "Monat",
  EXTSEARCH_DATEINPUT_YEAR: "Jahr",
  EXTSEARCH_DELETE_ALERT: "Möchten Sie diese gespeicherte Suche wirklich löschen?",
  EXTSEARCH_DELETE_ALERT_GROUP: "Möchten Sie diese Kontaktgruppe wirklich löschen?",
  EXTSEARCH_ELEMENT_AND: "UND",
  EXTSEARCH_ENTER_NAME: "Bitte geben Sie einen Namen für diese Suche ein.",
  EXTSEARCH_ENTER_NAME_TITLE: "Fehlender Name",
  EXTSEARCH_GROUP_COUNT: "Anzahl",
  // EXTSEARCH_INVALID: "Dies ist keine gültige Suchkonfiguration. Bitte wählen Sie mindestens ein Suchfeld aus.",
  EXTSEARCH_INVALID: "Dies ist keine gültige Suchkonfiguration.",
  EXTSEARCH_INVALID_FIELD: "Bitte wählen Sie mindestens ein Suchfeld aus.",
  // EXTSEARCH_INVALID_CATEGORY: "Dies ist keine gültige Suchkonfiguration. Bitte wählen Sie bei Verwendung von 'ist eins von' oder 'ist nicht eins von' mindestens einen Listenpunkt aus.",
  EXTSEARCH_INVALID_CATEGORY: "Bitte wählen Sie mindestens einen Wert aus, wenn Sie 'ist einer von' oder 'ist nicht eins von' verwenden.",
  // EXTSEARCH_INVALID_DATE: "Dies ist keine gültige Suchkonfiguration. Bitte geben Sie ein Datum ein.",
  EXTSEARCH_INVALID_DATE: "Bitte geben Sie ein gültiges Datum ein.",
  EXTSEARCH_INVALID_GROUP: "Bitte geben Sie dieser Kontaktgruppe einen Namen",
  EXTSEARCH_INVALID_TITLE: "Ungültige Suche",
  EXTSEARCH_MULTITEXT_OR: "oder",
  EXTSEARCH_NAME: "Name der Suche",
  EXTSEARCH_NAME_GROUP: "Name der Gruppe",
  EXTSEARCH_NOTES_ITEM: "Bemerkung",
  EXTSEARCH_NOTES_SEPARATOR: "Sonstiges",
  EXTSEARCH_OBSOLETE_IDS_CATLIST: "Veraltete Kategorielisten",
  EXTSEARCH_OBSOLETE_IDS_CATVALUE: "Veraltete Kategoriewerte",
  EXTSEARCH_OBSOLETE_IDS_FF: "Veraltete Freifelder",
  EXTSEARCH_OBSOLETE_TEXT: "In dieser Suche werden veraltete Felder verwendet, die im System nicht mehr existieren. Diese Felder wurden aus der Ansicht entfernt. Speichern Sie diese Suche erneut ab, um die Referenzen auf die veralteten Felder zu entfernen.",
  EXTSEARCH_OBSOLETE_TITLE: "Ungültige Felder",
  EXTSEARCH_OP_BEGINSWITH: "beginnt mit",
  EXTSEARCH_OP_BEGINSWITHNOT: "beginnt nicht mit",
  EXTSEARCH_OP_CONTAINS: "enthält",
  EXTSEARCH_OP_CONTAINSNOT: "enthält nicht",
  EXTSEARCH_OP_DATE_AFTER: "ist nach",
  EXTSEARCH_OP_DATE_BEFORE: "ist vor",
  EXTSEARCH_OP_DATE_ON: "ist am",
  EXTSEARCH_OP_ENDSWITH: "endet mit",
  EXTSEARCH_OP_ENDSWITHNOT: "endet nicht mit",
  EXTSEARCH_OP_IS: "ist",
  EXTSEARCH_OP_ISCHECKED: "ist eingeschaltet",
  EXTSEARCH_OP_ISCHECKEDNOT: "ist ausgeschaltet",
  EXTSEARCH_OP_ISEMPTY: "ist leer",
  EXTSEARCH_OP_ISEMPTYNOT: "ist nicht leer",
  EXTSEARCH_OP_ISGREATER: "ist größer",
  EXTSEARCH_OP_ISGREATEREQUAL: "ist größer oder gleich",
  EXTSEARCH_OP_ISIN: "ist eins von",
  EXTSEARCH_OP_ISINNOT: "ist nicht eins von",
  EXTSEARCH_OP_ISLESS: "ist kleiner",
  EXTSEARCH_OP_ISLESSEQUAL: "ist kleiner oder gleich",
  EXTSEARCH_OP_ISNOT: "ist nicht",
  EXTSEARCH_PREVIEW_GROUP: "Als Suchergebnis anzeigen",
  EXTSEARCH_PREVIEW_SEARCH: "Suche ausführen",
  EXTSEARCH_REMOVE_BLOCK_TT: "Suchblock entfernen",
  EXTSEARCH_RESET_ALERT: "Möchten Sie diese Sucheinstellungen wirklich zurücksetzen?",
  EXTSEARCH_SAVEAS_HEADER: "Erweiterte Suche speichern",
  EXTSEARCH_SAVEAS_HEADER_GROUP: "Kontaktgruppe speichern",
  EXTSEARCH_SEARCH_BLOCK_OR: "ODER",
  EXTSEARCH_SELECT_SEARCH_FIELD: "[Feld wählen...]",
  EXTSEARCH_TITLE: "Erweiterte Suche",
  EXTSEARCH_TITLE_GROUP: "Kontaktgruppe",
  EXTSEARCH_USAGE_CONFIRM_DELETE: "Möchten Sie mit der Löschung fortfahren?",
  EXTSEARCH_USAGE_CRITICAL: "davon {0} zum Versand freigegeben",
  EXTSEARCH_USAGE_DELETION_IMPOSSIBLE: "Löschen verboten",
  EXTSEARCH_USAGE_DELETION_POSSIBLE: "Löschen bestätigen",
  EXTSEARCH_USAGE_DETAIL_TT: "Hier klicken um Details zur Verwendung dieser Suche in Mailings anzuzeigen.",
  EXTSEARCH_USAGE_LOCK_EXPLANATION: "Diese Suche darf weder gelöscht noch verändert werden, da sie in einem Mailing verwendet wird, welches zum Versand freigegeben ist.",
  EXTSEARCH_USAGE_LOCK_EXPLANATION_FOLDER: "Dieser Ordner darf nicht gelöscht werden, da er Suchen enthält, die in einem Mailing verwendet werden, welches zum Versand freigegeben ist.",
  EXTSEARCH_USAGE_PANEL_DESC: "Diese Suche wird in folgenden Mailings verwendet:",
  EXTSEARCH_USAGE_PANEL_DESC_FOLDER: "Die Suchen in diesem Ordner werden in folgenden Mailings verwendet:",
  EXTSEARCH_USAGE_PANEL_TITLE: "Verwendung in Mailings",
  EXTSEARCH_USAGE_TABLE_NAME: "Name",
  EXTSEARCH_USAGE_TABLE_STATUS: "Status",
  EXTSEARCH_USAGE_TOTAL_1: "verwendet in",
  EXTSEARCH_USAGE_TOTAL_2: "{0} Mailings",
  FILE_UPLOAD_BUTTON: "Hochladen",
  FILE_UPLOAD_DESCRIPTION: "Beschreibung",
  FILE_UPLOAD_FILE: "Datei",
  FILE_UPLOAD_TITLE: "Datei Upload",
  GENERIC_APPLY: "Übernehmen",
  GENERIC_BACK: "Zurück",
  GENERIC_CANCEL: "Abbrechen",
  GENERIC_CLOSE: "Schließen",
  GENERIC_COMBO_CHOOSE_VALUE: "[Wert auswählen...]",
  GENERIC_DELETE: "Löschen",
  GENERIC_DELETE_ALERT_TITLE: "Löschen bestätigen",
  GENERIC_DISCARD: "Verwerfen",
  GENERIC_EDIT: "Bearbeiten",
  GENERIC_EXPORT: "Exportieren",
  GENERIC_FILTER_CLEAR_TT: "Filter entfernen",
  GENERIC_FILTER_DESC_TT: "Filterbegriff eingeben",
  GENERIC_HINT: "Hinweis",
  GENERIC_LOADING: "Die Daten werden geladen, bitte warten Sie...",
  GENERIC_MISSING_RIGHTS: "Sie besitzen keine Berechtigung für diese Aktion.",
  GENERIC_MISSING_RIGHTS_DELETE_FOLDER: "Sie besitzen keine Berechtigung, eines der Elemente innerhalb dieses Ordners zu löschen.",
  GENERIC_NO: "Nein",
  GENERIC_NO_SELECTION: "Keine Auswahl",
  GENERIC_OBJECT_NOT_FOUND_TEXT: "Dieses Objekt konnte nicht geladen werden. Vermutlich wurde es zwischenzeitlich gelöscht.",
  GENERIC_OBJECT_NOT_FOUND_TITLE: "Fehlender Datensatz",
  GENERIC_OK: "Ok",
  GENERIC_ONBEFOREUNLOAD_MESSAGE: "Achtung: Sie sind im Begriff, das FairMate CRM zu schließen.",
  GENERIC_OPEN: "Öffnen",
  GENERIC_QUICKSEARCH_NORESULT: "Die Schnellsuche lieferte keine Ergebnisse. Bitte ändern Sie ihre Eingabe.",
  GENERIC_READ_ONLY: "schreibgeschützt",
  GENERIC_REFRESH: "Aktualisieren",
  GENERIC_SAVE: "Speichern",
  GENERIC_SAVEAS: "Speichern unter...",
  GENERIC_TEXT_CLEAR_TT: "Eingabefeld leeren",
  GENERIC_UNSAVEABLE_CHANGES: "Möchten Sie ihre Änderungen verwerfen?",
  GENERIC_UNSAVED_CHANGES: "Möchten Sie ihre Änderungen speichern?",
  GENERIC_UNSAVED_CHANGES_TITLE: "Nicht gespeicherte Änderungen",
  GENERIC_YES: "Ja",
  HEADER_ADMIN: "Verwaltung",
  HEADER_DIMEDIS: "dimedis GmbH, Köln",
  HEADER_HISTORY: "Verlauf",
  HEADER_HOME: "Dashboard",
  HEADER_NEW_CONTACT: "Neuer Kontakt",
  HEADER_QUICKSEARCH_LABEL: "Schnellsuche in Name, Vorname, Firma, E-Mail",
  HEADER_QUICKSEARCH_NO_RESULT: "Die Schnellsuche lieferte keine Ergebnisse. Bitte versuchen Sie eine erweiterte Suche.",
  HEADER_USERMENU_LOGOUT: "Sitzung beenden",
  HEADER_VERSION: "Version",
  HISTORY_LABEL_RESULT: "Suchergebnis",
  HOME_ADMINISTRATOR: "Administrator",
  HOME_CHECKBOX_MY_MAILINGS: "Meine Mailings",
  HOME_CHECKBOX_OLD_MAILINGS: "Alte Mailings anzeigen",
  HOME_CHECKBOX_OTHER_MAILINGS: "Andere Mailings",
  HOME_DATETIME_FORMAT: "DD.MM.YYYY",
  HOME_LOGOUT: "Beenden",
  HOME_MAILINGS_ALL_NOTE: "Alle Mailings werden angezeigt.",
  HOME_MAILINGS_DISPATCH_NOTE: "Es werden nur Mailings mit Versanddatum angezeigt.",
  HOME_TABLE_CAMPAIGN: "Kampagne",
  HOME_TABLE_DATE: "Versanddatum",
  HOME_TABLE_FOLDER: "Ordner",
  HOME_TABLE_MAILING: "Mailing",
  HOME_TABLE_PROGRESS: "Status",
  HOME_TABLE_RESPONSIBLE: "Verantwortlich",
  HOME_TABLE_SHOW_STATS_TT: "Mailing-Statistik anzeigen",
  HOME_USER: "Benutzer",
  LINK_TA_BUTTON_TT: "Link hinzufügen",
  LINK_TA_POPUP_BTN_OK: "Link hinzufügen",
  LINK_TA_POPUP_LABEL_LINK: "Link / URL",
  LINK_TA_POPUP_LABEL_TITLE: "Bezeichnung",
  LINK_TA_POPUP_TITLE: "Link hinzufügen",
  LOCALE_CAMPAIGN_AXIS_DAY: "DD.MM.YYYY",
  LOCALE_CAMPAIGN_AXIS_DAY_CHART: "DD MMM",
  LOCALE_CAMPAIGN_AXIS_MONTH: "MM.YYYY",
  LOCALE_CAMPAIGN_AXIS_MONTH_CHART: "MM YYYY",
  LOCALE_CAMPAIGN_AXIS_YEAR: "YYYY",
  LOCALE_DATETIME_FORMAT: "DD.MM.YY, HH:mm:ss",
  LOCALE_DATETIME_FORMAT_SHORT: "DD.MM.YYYY, HH:mm",
  LOCALE_DATE_FORMAT: "DD/MM/YYYY",
  LOCALE_DATE_RANGE_FORMAT: "dd/MM/yyyy",
  LOCALE_MONTH_APR: "April",
  LOCALE_MONTH_AUG: "August",
  LOCALE_MONTH_DEC: "Dezember",
  LOCALE_MONTH_FEB: "Februar",
  LOCALE_MONTH_JAN: "Januar",
  LOCALE_MONTH_JUL: "Juli",
  LOCALE_MONTH_JUN: "Juni",
  LOCALE_MONTH_MAR: "März",
  LOCALE_MONTH_MAY: "Mai",
  LOCALE_MONTH_NOV: "November",
  LOCALE_MONTH_OCT: "Oktober",
  LOCALE_MONTH_SEP: "September",
  LOCALE_THOUSANDS_SEPARATOR: ".",
  LOCALE_TIME_FORMAT_SHORT: "HH:mm",
  LOCALE_WEEKDAY_ABBR_FRI: "Fr",
  LOCALE_WEEKDAY_ABBR_MON: "Mo",
  LOCALE_WEEKDAY_ABBR_SAT: "Sa",
  LOCALE_WEEKDAY_ABBR_SUN: "So",
  LOCALE_WEEKDAY_ABBR_THU: "Do",
  LOCALE_WEEKDAY_ABBR_TUE: "Di",
  LOCALE_WEEKDAY_ABBR_WED: "Mi",
  LOGIN_FAILED: "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Benutzername und Passwort.",
  LOGIN_HEADER: "Login",
  LOGIN_LOGIN: "Anmelden",
  LOGIN_NOACCESS: "Dieser Benutzer-Account hat keine Zugriffsrechte auf das FairMate CRM.",
  LOGIN_PASSWORD: "Passwort",
  LOGIN_SESSION_EXPIRED: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich neu an.",
  LOGIN_USERNAME: "Benutzername",
  MAILING: "Mailing",
  MAILING_EMAIL_PLACEHOLDER: "\"Your Name\" <your@domain.com>",
  MAILING_APPROVE: "Zum Versand freigeben",
  MAILING_CHOOSE_TEMPLATE: "Auswählen",
  MAILING_CHOOSE_TEMPLATE_TT: "Andere Mail-Vorlage aussuchen",
  MAILING_CHOOSE_UNSUBSCRIBE_TT: "Anderen Unsubscribe-Link aussuchen",
  MAILING_CLEAR_TIME_TT: "Versandzeit löschen",
  MAILING_COUNT_RECIPIENTS_ALL_TT: "Alle E-Mail Adressen, inkl. Duplikate",
  MAILING_COUNT_RECIPIENTS_TT: "Adressaten zählen",
  MAILING_COUNT_RECIPIENTS_UNIQUE_TT: "Eindeutige E-Mail Adressen, ohne Duplikate",
  MAILING_DATE: "Datum",
  MAILING_DELETE: "Löschen",
  MAILING_DELETE_ALERT: "Möchten Sie dieses Mailing wirklich löschen?",
  MAILING_DELETE_FOLDER_ALERT: "Dieser Ordner kann nicht gelöscht werden, da er Mailings enthält, die zum Versand freigegeben sind.",
  MAILING_DELETE_RELEASED_ALERT: "Dieses Mailing ist zum Versand freigegeben. Um es zu löschen, müssen Sie zunächst die Freigabe widerrufen.",
  MAILING_DELETE_SENDING_ALERT: "Dieses Mailing wird gerade versendet. Es kann nicht gelöscht werden.",
  MAILING_DISPATCH_DATE: "Versanddatum",
  MAILING_DISPATCH_PAST: "Die Versandzeit liegt in der Vergangenheit.",
  MAILING_DISPATCH_PAST_CONFIRM: "Der Versand-Zeitpunkt liegt in der Vergangenheit. Möchten Sie trotzdem fortsetzen?",
  MAILING_DISPATCH_PAST_CONFIRM_YES: "Ja, Versand fortsetzen.",
  MAILING_DISPATCH_PAST_CONFIRM_NO: "Nein, den Versand abbrechen und Datum und Uhrzeit ändern.",
  MAILING_DISPATCH_TIME: "Versandzeit",
  MAILING_EDIT_TEMPLATE_TT: "Mailing Template in @it bearbeiten",
  MAILING_EDIT_UNSUBSCRIBE_TT: "Unsubscribe Link in @it bearbeiten",
  MAILING_FROM: "Absender",
  MAILING_LANGUAGE: "Sprache",
  MAILING_MAIN_DATA: "Versanddaten",
  MAILING_ENTER_NAME: "Bitte geben Sie einen Namen für dieses Mailing ein.",
  MAILING_ENTER_NAME_TITLE: "Fehlender Name",
  MAILING_MISSING_DISPATCH: "Die Versandzeit muss ausgefüllt sein.",
  MAILING_MISSING_EMAIL_DISPLAYNAME: "Der Absender ist ungültig. Das richtige Format zur Verwendung einer E-Mail Adresse mit Adresszusatz ist:\nMax Mustermann <mustermann@beispiel.de>",
  MAILING_MISSING_EMAIL_INVALID: "Der Absender muss eine gültige E-Mail Adresse enthalten. Beispiel: mustermann@beispiel.de",
  MAILING_MISSING_FIELDS: "Dieses Mailing kann nicht freigegeben werden, da notwendige Angaben fehlen.",
  MAILING_MISSING_FIELDS_TITLE: "Ungültiges Mailing",
  MAILING_MISSING_OFFLINE: "Die Mail-Vorlage ist in @it nicht online geschaltet.",
  MAILING_MISSING_RECIPIENTS: "Es sind keine Adressaten ausgewählt.",
  MAILING_MISSING_SENDER: "Der Absender muss ausgefüllt sein.",
  MAILING_MISSING_SUBJECT: "Die Betreffzeile muss ausgefüllt sein.",
  MAILING_MISSING_TEMPLATE: "Eine Mail-Vorlage muss ausgewählt sein.",
  MAILING_NAME: "Name",
  MAILING_NOT_SAVED: "Bitte speichern Sie das Mailing zunächst ab.",
  MAILING_OWNER: "Verantwortlich",
  MAILING_PREVIEW_HTML: "HTML Vorschau",
  MAILING_PREVIEW_HTML_TT: "HTML-Version des Mailings in neuem Fenster anzeigen",
  MAILING_PREVIEW_TEXT: "Text Vorschau",
  MAILING_PREVIEW_TEXT_TT: "Text-Version des Mailings in neuem Fenster anzeigen",
  MAILING_RECIPIENTS: "Adressaten",
  MAILING_RECIPIENTS_DRAG_HERE: "Suchen per Drag&Drop aus Hauptnavigation einfügen.",
  MAILING_RECIPIENTS_SEARCH: "Gespeicherte Suche oder Kontaktgruppe eingeben",
  MAILING_REMOVE_RECIPIENT_TT: "Ausgewählten Eintrag entfernen",
  MAILING_RESET_ALERT: "Möchten Sie wirklich alle Einstellungen dieses Mailings zurücksetzen?",
  MAILING_REVOKE: "Freigabe widerrufen",
  MAILING_SAVE: "Speichern",
  MAILING_SAVEAS_HEADER: "Mailing speichern",
  MAILING_SAVE_AS: "Speichern unter...",
  MAILING_SEND_NOW: "Sofort!",
  MAILING_SEND_NOW_TT: "Versandzeit auf die jetzige Uhrzeit stellen",
  MAILING_SEND_ONCE: "Bei doppelten E-Mail-Adressen nur 1x senden",
  MAILING_STATUS: "Status",
  MAILING_STATUS_CLOSED: "abgeschlossen",
  MAILING_STATUS_CLOSED_COUNT: "E-Mails versendet: {0}",
  MAILING_STATUS_OPEN: "offen",
  MAILING_STATUS_RELEASED: "freigegeben",
  MAILING_STATUS_RELEASED_IMMEDIATE: "Warte auf Versand...",
  MAILING_STATUS_RELEASED_SCHEDULED_AT: "Versand um {0}",
  MAILING_STATUS_RELEASED_SCHEDULED_DAYS: "Versand in {0} Tagen",
  MAILING_STATUS_RELEASED_SCHEDULED_HOUR: "Versand in < 1 Stunde",
  MAILING_STATUS_RELEASED_SCHEDULED_HOURS: "Versand in {0} Stunden",
  MAILING_STATUS_RELEASED_SCHEDULED_MONTH: "Versand in > 1 Monat",
  MAILING_STATUS_SENDING: "Versand läuft",
  MAILING_STATUS_SENDING_STARTED: "Versand gestartet!",
  MAILING_SUBJECT: "Betreff",
  MAILING_TEMPLATE: "Mail Vorlage",
  MAILING_TEMPLATE_GUIDE_BUTTON: "Platzhalter Hilfe",
  MAILING_TESTMAIL_BUTTON: "Preview Versand...",
  MAILING_TIME: "Uhrzeit",
  MAILING_UNSUBSCRIBE: "Unsubscribe Link",
  MAILING_VIEW_RECIPIENTS_CM: "Suchergebnis anzeigen",
  MAILING_VIEW_STATISTICS: "Statistik",
  MASSEDIT_ACTION_CLEAR: "leeren",
  MASSEDIT_ACTION_DESELECT: "deselektieren",
  MASSEDIT_ACTION_SELECT: "selektieren",
  MASSEDIT_ACTION_SETTEXT: "ersetzen",
  MASSEDIT_ALERT_TEXT: "Diese Massenänderung enthält ungültige Anweisungen. Bitte überprüfen Sie die Einstellungen.",
  MASSEDIT_ALERT_TITLE: "Ungültige Anweisung",
  MASSEDIT_FOOTER: "Hinweis: Durch das Setzen neuer Werte ändert sich möglicherweise das angezeigte Suchergebnis. Ihre Markierungen werden nach dem Anwenden der Änderungen entfernt.",
  MASSEDIT_NUMBER_CONTACTS: "Ausgewählte Kontakte:",
  MASSEDIT_NUMBER_INCLUDED: "Anzahl der enthaltenen Kontakte: {0}",
  MASSEDIT_PROMPT_CHOOSE_ACTION: "[Aktion wählen...]",
  MASSEDIT_PROMPT_CHOOSE_FIELD: "[Feld wählen...]",
  MASSEDIT_PROMPT_CHOOSE_VALUE: "[Wert wählen...]",
  MASSEDIT_RUN: "Änderungen anwenden",
  MASSEDIT_TITLE: "Massenänderung",
  MERGE_ADDRESS_BUTTON_EXECUTE: "Adresse übernehmen",
  MERGE_ADDRESS_BUTTON_MASTER: "Alle Felder auswählen",
  MERGE_ADDRESS_INFO_TEXT: "Wählen Sie die beste Adresse per Klick auf die Krone aus. Anschließend können Sie bei Bedarf einzelne Felder aus den anderen Spalten wählen, um die Datenqualität zu verbessern. Sobald Sie mit dem Endergebnis zufrieden sind, klicken Sie auf 'Adresse übernehmen'.",
  MERGE_ADDRESS_NOADDRESSES_TEXT: "Es wurden keine Adressen zur Firma '{0}' gefunden.",
  MERGE_ADDRESS_NOADDRESSES_TITLE: "Keine Daten gefunden",
  MERGE_ADDRESS_PANEL_TITLE: "Firmenadresse übernehmen",
  MERGE_ALERT_TITLE: "Doppelten-Abgleich",
  MERGE_ATLEASTTWO_ALERT: "Für den Doppelten-Abgleich müssen auf dieser Seite mindestens 2 Kontakte ausgewählt sein.",
  MERGE_BOUNCED_TT: "E-Mail Adresse ist als 'bounced' markiert",
  MERGE_BUTTON_EXCLUDE: "Ausschließen",
  MERGE_BUTTON_EXECUTE: "Datensätze vereinen",
  MERGE_BUTTON_MASTER: "Master",
  MERGE_LAST_LOGIN_TT: "Letzter Login mit diesem Account (public)",
  MERGE_MAXCONTACTS_ALERT: "Für den Doppelten-Abgleich dürfen nicht mehr als {0} Kontakte ausgewählt sein.",
  MERGE_MINIMUM_TEXT: "Sie haben zu viele Datensätze ausgeschlossen. Um den Abgleich-Prozess durchzuführen müssen mindestens zwei Spalten aktiv sein.",
  MERGE_MINIMUM_TITLE: "Achtung: Kein Abgleich möglich",
  MERGE_MULTICAT_INTRO: "Kategorien mit Mehrfachauswahl...",
  MERGE_MULTICAT_JOIN: "... aus allen Kontakten vereinen",
  MERGE_MULTICAT_MASTER: "... vom Master-Kontakt übernehmen",
  MERGE_NO_ACCOUNT: "[ohne Account]",
  MERGE_NO_LOGIN: "[kein Login verzeichnet]",
  MERGE_NUMBER_INCLUDED: "Anzahl einbezogener Datensätze: {0}",
  MERGE_PANEL_TITLE: "Dubletten-Abgleich",
  MERGE_RESULT_TITLE: "Endergebnis",
  MERGE_STEP1_TEXT: "Als Master-Kontakt sollten Sie den Datensatz mit der besten Datenqualität wählen. Während des Abgleich-Prozesses können Sie ihn mit Daten aus den anderen Kontakten anreichern. Nach dem Abgleich-Prozess werden alle eingeschlossenen Kontakte bis auf den (evtl. angereicherten) Master-Kontakt gelöscht.",
  MERGE_STEP1_TITLE: "Schritt 1: Master auswählen",
  MERGE_STEP2_TEXT: "Datensätze, die nicht in den Abgleich-Prozess einbezogen werden sollen, können Sie per 'Ausschließen' deaktivieren. Ein solcher Datensatz bleibt im Folgenden unangetastet und wird nach dem Abgleich nicht gelöscht. Um die Datenqualität des Masters zu verbessern, können Sie in den anderen Spalten auf die Felder klicken, die in das Endergebnis übergehen sollen.",
  MERGE_STEP2_TITLE: "Schritt 2: Ausschließen und Anreichern",
  NAVI_CONFIRM_DELETE_MAILING: "Möchten Sie das Mailing '{0}' wirklich löschen?",
  NAVI_CONFIRM_DELETE_PRINTMAIL: "Möchten Sie das Print Mailing '{0}' wirklich löschen?",
  NAVI_CONFIRM_DELETE_SEARCH: "Möchten Sie die gespeicherte Suche '{0}' wirklich löschen?",
  NAVI_DELETE_CAMPAIGN_CM: "Kampagne löschen",
  NAVI_DELETE_FOLDER_CM: "Ordner löschen",
  NAVI_DELETE_GROUP_CM: "Kontaktgruppe löschen",
  NAVI_DELETE_MAILING_CM: "Mailing löschen",
  NAVI_DELETE_PRINTMAIL_CM: "Print Mailing löschen",
  NAVI_DELETE_SEARCH_CM: "Suche löschen",
  NAVI_EDIT_CAMPAIGN_CM: "Kampagne bearbeiten",
  NAVI_EDIT_GROUP_CM: "Kontaktgruppe bearbeiten",
  NAVI_EDIT_MAILING_CM: "Mailing bearbeiten",
  NAVI_EDIT_PRINTMAIL_CM: "Print Mailing bearbeiten",
  NAVI_EDIT_SEARCH_CM: "Suche bearbeiten",
  NAVI_EXECUTE_GROUP_CM: "Kontaktgruppe anzeigen",
  NAVI_EXECUTE_SEARCH_CM: "Suche ausführen",
  NAVI_FOLDER_READONLY_MAILINGS: "Dieses Objekt kann nicht gelöscht werden, da es Mailings anderer Benutzer enthält.",
  NAVI_FOLDER_WITH_CHILDREN: "Die Unterobjekte in diesem Ordner werden ebenfalls gelöscht.\nWollen Sie die Aktion trotzdem durchführen?",
  NAVI_MAILINGS_TITLE: "Kampagnen",
  NAVI_MAILINGS_NO_RESULTS: "Keine Daten gefunden",
  NAVI_NEW_CAMPAIGN_CM: "Neue Kampagne",
  NAVI_NEW_CAMPAIGN_TT: "Neue Kampagne anlegen",// "Neue Kampagne auf oberster Ebene anlegen"
  NAVI_NEW_FOLDER_CM: "Neuer Ordner",
  NAVI_NEW_FOLDER_TT: "Neuen Ordner anlegen",// "Neuen Ordner auf oberster Ebene anlegen"
  NAVI_NEW_GROUP_CM: "Neue Kontaktgruppe",
  NAVI_NEW_GROUP_TT: "Neue Kontaktgruppe anlegen",// "Neue Kontaktgruppe auf oberster Ebene anlegen"
  NAVI_NEW_MAILING_CM: "Neues Mailing",
  NAVI_NEW_MAILING_TT: "Neues Mailing anlegen",// "Neues Mailing auf oberster Ebene anlegen"
  NAVI_NEW_PRINTMAIL_CM: "Neues Print Mailing",
  NAVI_NEW_SEARCH_CM: "Neue Suche",
  NAVI_NEW_SEARCH_TT: "Neue Suche anlegen",// "Neue Suche auf oberster Ebene anlegen"
  NAVI_NODROP_CAMPAIGN: "Eine Kampagne darf keine untergeordnete Kampagne enthalten",
  NAVI_NODROP_NOT_OWNER: "Sie dürfen dieses Objekt nicht verschieben, da es Ihnen nicht gehört",
  NAVI_NODROP_READONLY_FOLDER: "Sie haben keine Schreibrechte auf den Zielordner",
  NAVI_NODROP_SUBFOLDER: "Ein Ordner kann nicht in seinen eigenen Unterordner verschoben werden",
  NAVI_NODROP_WRONG_TREE: "Objekte können nur innerhalb ihres eigenen Baums verschoben werden",
  NAVI_OVERLAY_HEAD_NEW_FOLDER: "Neuer Ordner",
  NAVI_OVERLAY_HEAD_CREATE: "Erstellen",
  NAVI_OVERLAY_HEAD_RENAME: "Umbenennen",
  NAVI_OVERLAY_HEAD_RENAME_FOLDER: "Ordner umbenennen",
  NAVI_OVERLAY_HEAD_RENAME_GROUP: "Gruppe umbenennen",
  NAVI_OVERLAY_HEAD_RENAME_SEARCH: "Suche umbenennen",
  NAVI_OVERLAY_HEAD_RENAME_CAMPAIGN: "Kampagne umbenennen",
  NAVI_OVERLAY_HEAD_RENAME_MAILING: "Mailing umbenennen",
  NAVI_READONLY_CAMPAIGN_CM: "Kampagne öffnen",
  NAVI_READONLY_GROUP_CM: "Kontaktgruppe öffnen",
  NAVI_READONLY_MAILING_CM: "Mailing öffnen",
  NAVI_READONLY_PRINTMAIL_CM: "Print Mailing öffnen",
  NAVI_READONLY_SEARCH_CM: "Suche öffnen",
  NAVI_REFRESH_NAVI_CM: "Hauptmenü aktualisieren",
  NAVI_RENAME_FOLDER_CM: "Ordner umbenennen",
  NAVI_RENAME_GROUP_CM: "Kontaktgruppe umbenennen",
  NAVI_RENAME_MAILING_CM: "Mailing umbenennen",
  NAVI_RENAME_PRINTMAIL_CM: "Print Mailing umbenennen",
  NAVI_RENAME_SEARCH_CM: "Suche umbenennen",
  NAVI_SEARCHES_TITLE: "Gespeicherte Suchen",
  NAVI_SEARCHES_NO_RESULTS: "Keine Daten gefunden",
  NAVI_SHOW_ALL_CONTACTS_CM: "Alle Kontakte anzeigen",
  NAVI_TOMAILING_GROUP_CM: "!!!Add group to mailing",
  NAVI_TOMAILING_SEARCH_CM: "!!!Add search to mailing",
  PROCESSING_POPUP_CONTENT: "Ein lang dauernder Prozess wurde gestartet. Bitte warten.",
  PROCESSING_POPUP_TITLE: "Hinweis",
  REPORTING_BUTTON_HIDE_VALUES: "Werte ein-/ausblenden",
  REPORTING_BUTTON_WHERE_EXTSEARCH: "Aus Suche",
  REPORTING_BUTTON_WHERE_EXTSEARCH_TT: "Personenkreis durch gespeicherte Suche oder Kontaktgruppe festlegen.",
  REPORTING_BUTTON_WHERE_MANUAL: "Manuell",
  REPORTING_BUTTON_WHERE_MANUAL_TT: "Kriterien für den Personenkreis manuell auswählen.",
  REPORTING_CB_ALL_PERSONS: "[Alle Personen]",
  REPORTING_CB_NO_CATEGORY: "[Keine Kategorie]",
  REPORTING_DOWNLOAD_CHART_CM: "Grafik speichern unter...",
  REPORTING_DOWNLOAD_EXCEL_CM: "Daten nach Excel exportieren...",
  REPORTING_HEADING_GROUP: "aufgeschlüsselt nach",
  REPORTING_HEADING_WHERE: "Personenkreis",
  REPORTING_HINT_SAVED_SEARCH: "Ziehen Sie eine gespeicherte Suche oder Kontaktgruppe aus der linken Navigationsspalte in dieses Feld, um den Personenkreis zu bestimmen.",
  REPORTING_LABEL_ALL: "[alle]",
  REPORTING_LABEL_UNGROUPED: "[ohne Zuordnung]",
  REPORTING_NUM_EXCLUDED: "davon nicht im Diagramm",
  REPORTING_NUM_EXCLUDED_TT: "Summe aller Zuordnungen, die entweder\na) über 'Werte ein-/ausblenden' manuell ausgeblendet wurden, oder\nb) unter 'Sonstige' aufsummiert werden während der 'Sonstige'-Balken in den Optionen deaktiviert ist.",
  REPORTING_NUM_GROUPED: "Zuordnungen gesamt",
  REPORTING_NUM_GROUPED_TT: "Summe aller Zuordnungen in der gewählten Kategorie (siehe 'aufgeschlüsselt nach') bei Personen aus dem oben gewählten Personenkreis. Enthält Mehrfachzählungen, wenn einer Person mehrere Werte aus dieser Kategorie zugeordnet sind.",
  REPORTING_NUM_UNGROUPED: "Personen ohne Zuordnung",
  REPORTING_NUM_UNGROUPED_TT: "Anzahl aller Personen aus dem oben gewählten Personenkreis, die keine Zuordnung in der gewählten Kategorie  haben (siehe 'aufgeschlüsselt nach').",
  REPORTING_OPTIONS: "Optionen",
  REPORTING_OPTIONS_DATA_LABELS: "Balken beschriften",
  REPORTING_OPTIONS_OTHER: "Sonstige",
  REPORTING_OPTIONS_SHOW_MAX_1: "Maximal",
  REPORTING_OPTIONS_SHOW_MAX_2: "Werte anzeigen",
  REPORTING_OPTIONS_SORT_BYVALUE: "nach Größe",
  REPORTING_OPTIONS_SORT_ALPHA_ALLVALUES: "alphabetisch",
  REPORTING_OPTIONS_SORT_ALPHA_TOPVALUES: "nach Größe und alphabetisch",
  REPORTING_OPTIONS_SORT_TITLE: "Sortierung",
  REPORTING_OPTIONS_VIEW_TITLE: "Anzeige",
  REPORTING_OPTIONS_SUM_OTHER: "Sonstige aufsummieren",
  REPORTING_SAVED_BTN_LOAD: "Laden",
  REPORTING_SAVED_BTN_UPDATE: "Überschreiben",
  REPORTING_SAVED_DELETE_ALERT: "Möchten Sie diesen gespeicherten Report wirklich löschen?",
  REPORTING_SAVED_DEMO_TITLE: "Demo: Top 10 Nicht-EU Länder",
  REPORTING_SAVED_HINT_EXISTING: "Der gewählte Report wird mit den aktuellen Einstellungen überschrieben. Alternativ können Sie den Namen ändern, um einen neuen Report zu erzeugen.",
  REPORTING_SAVED_HINT_NEW2: "Alternativ können Sie oben in der Liste einen bestehenden Report auswählen, um ihn zu überschreiben.",
  REPORTING_SAVED_HINT_NEW: "Es wird ein neuer Report unter diesem Namen abgespeichert.",
  REPORTING_SAVED_NO_REPORTS: "Keine gespeicherten Reports",
  REPORTING_SAVED_SECTION_LOAD: "Report laden",
  REPORTING_SAVED_SECTION_SAVE: "Report speichern unter...",
  REPORTING_SAVED_TITLE: "Report laden / speichern",
  REPORTING_TITLE_ALL_PERSONS: "Alle Personen",
  REPORTING_TITLE_GROUPED_BY: "aufgeschlüsselt nach",
  REPORTING_TITLE_PERSONS_WITH: "Personen",
  REPORTING_TYPE_BARCHART: "Balkendiagramm",
  REPORTING_TYPE_COLUMNCHART: "Säulendiagramm",
  REPORTING_TYPE_PIECHART: "Kuchendiagramm",
  REPORTING_WARN_UNKNOWN_CATEGORIES: "In diesem Report verwendete Kategorielisten existieren nicht mehr. Die entsprechenden Einstellungen wurden daher verworfen.",
  REPORTING_WARN_UNKNOWN_QUERY: "Die in diesem Report verwendete gespeicherte Suche existiert nicht mehr. Die Personenauswahl wurde dementsprechend verworfen.",
  RESUBMISSION_DELETE_ALERT: "Möchten Sie diese Wiedervorlage wirklich löschen?\n\nHinweis: Der Eintrag wird vollständig gelöscht, inklusive Kommentar. Falls Sie die Wiedervorlage nur deaktivieren wollen, benutzen Sie bitte die 'Erledigt'-Checkbox am Eintrag.",
  RESUBMISSION_TITLE: "Wiedervorlage",
  RESULTS_ALL_CONTACTS: "Alle Kontakte",
  RESULTS_BACK_TO_CONTACT: "Zurück zum Kontaktfenster",
  RESULTS_BACK_TO_COUNTRYFIX: "Zurück zur Länderkorrektur",
  RESULTS_BACK_TO_GROUP: "Zurück zur Kontaktgruppe",
  RESULTS_BACK_TO_MAILING: "Zurück zum Mailing",
  RESULTS_BACK_TO_REPORT: "Zurück zum Report",
  RESULTS_BACK_TO_SEARCH: "Zurück zur Suchmaske",
  RESULTS_COLUMN_NO_EDIT_NO_SORT_TT: "Bearbeiten und Sortieren nicht möglich.",
  RESULTS_COLUMN_NO_EDIT_TT: "Bearbeiten nicht möglich.",
  RESULTS_COLUMN_NO_SORT_TT: "Sortieren nicht möglich.",
  RESULTS_CONFIRM_MULTI_DELETE: "Mit dieser Aktion werden {0} Kontakte unwiderruflich aus der Datenbank gelöscht. Möchten Sie fortfahren?",
  RESULTS_CONTACTGROUP_PANEL_ALERT_COMBOBOX_TITLE: "Keine Auswahl",
  RESULTS_CONTACTGROUP_PANEL_ALERT_COMBOBOX_TXT: "Bitte wählen Sie eine Kontaktgruppe aus",
  RESULTS_CONTACTGROUP_PANEL_ALERT_TEXTFIELD_TITLE: "Kein Name",
  RESULTS_CONTACTGROUP_PANEL_ALERT_TEXTFIELD_TXT: "Bitte geben einen Namen für die neue Kontaktgruppe ein",
  RESULTS_CONTACTGROUP_PANEL_BT_TOGROUP: "Hinzufügen",
  RESULTS_CONTACTGROUP_PANEL_TITLE: "Zu Gruppe hinzufügen",
  RESULTS_CONTACTGROUP_PANEL_TXT_AMOUNT: "Ausgewählte Kontakte:",
  RESULTS_CONTACTGROUP_PANEL_TXT_NEWGROUP: "Zu neuer Kontaktgruppe hinzufügen",
  RESULTS_CONTACTGROUP_PANEL_TXT_TOGROUP: "Zu bestehender Gruppe hinzufügen",
  RESULTS_CONTACTS: "Kontakte",
  RESULTS_COUNTRYFIX_HEADER: "Kontakte mit dem fehlerhaften Land",
  RESULTS_CREATE_NEW_CONTACTGROUP_CM: "Markierte Kontakte zu Gruppe hinzufügen",
  RESULTS_DELETE_CONTACT_CM: "Kontakt löschen",
  RESULTS_DEL_MARKED_CONTACTS_CM: "Markierte Kontakte löschen",
  RESULTS_EDIT_CELL_CM: "Zelle bearbeiten",
  RESULTS_EDIT_GROUP: "Gruppe bearbeiten",
  RESULTS_EDIT_MARKED_CONTACTS_CM: "Markierte Kontakte bearbeiten",
  RESULTS_EDIT_SEARCH: "Suche bearbeiten",
  RESULTS_EMPLOYEES: "Mitarbeiter der Firma",
  RESULTS_EXPORT_MARKED_CONTACTS_CM: "Markierte Kontakte exportieren",
  RESULTS_EXT_SEARCH: "Erweiterte Suche",
  RESULTS_FIELD_COUNTRY_NAME: "Ländername",
  RESULTS_FREEFIELD_COLUMN_TT: "Freifeld. Bearbeiten und Sortieren nicht möglich.",
  RESULTS_GROUP: "Kontaktgruppe",
  RESULTS_IN_SEARCH_FIELDS: "in Name, Vorname, Firma",
  RESULTS_MARK_ALL_CM: "Alle markieren",
  RESULTS_MARK_INVERT_CM: "Markierung umkehren",
  RESULTS_MARK_NONE_CM: "Keine markieren",
  RESULTS_MERGE_MARKED_CONTACTS_CM: "Markierte Dubletten abgleichen",
  RESULTS_NAVI_DELETE: "Löschen",
  RESULTS_NAVI_EDIT: "Bearbeiten",
  RESULTS_NAVI_EXPORT: "Exportieren",
  RESULTS_NAVI_GROUP: "Gruppe",
  RESULTS_NAVI_MERGE: "Zusammenführen",
  RESULTS_NAVI_OPEN: "Öffnen",
  RESULTS_NEW_EXT_SEARCH: "Unbenannte erweiterte Suche",
  RESULTS_NEW_GROUP: "Unbenannte Kontaktgruppe",
  RESULTS_NO_RESULTS: "Die Suche lieferte keine Ergebnisse.",
  RESULTS_NO_SELECTION: "Es sind keine Kontakte gewählt.",
  RESULTS_NO_SELECTION_TITLE: "Keine Auswahl",
  RESULTS_NUM_SELECTED: "Ausgewählte Kontakte: {0}",
  RESULTS_OPEN_CONTACT_CM: "Kontakt öffnen",
  RESULTS_PER_PAGE: "Ergebnisse pro Seite",
  RESULTS_RANGE: "{0} bis {1} von {2} Ergebnissen",
  RESULTS_RECIPIENTS: "Adressatenkreis",
  RESULTS_REFRESH_CHECKBOX: "Suchergebnis automatisch aktualisieren",
  RESULTS_REFRESH_DESCRIPTION: "Wenn diese Option deaktiviert ist, wird das Suchergebnis nicht automatisch aktualisiert, sobald Änderungen an Kontakten vorgenommen werden.",
  RESULTS_REFRESH_RECOMMENDED_DISABLED_TT: "Die automatische Aktualisierung ist deaktiviert. Das Suchergebnis ist möglicherweise nicht mehr aktuell.",
  RESULTS_REFRESH_RECOMMENDED_TT: "Das Suchergebnis ist möglicherweise nicht mehr aktuell.",
  RESULTS_REFRESH_TITLE: "Automatische Aktualisierung",
  RESULTS_REPORT_DRILLDOWN_HEADER: "Reportergebnis",
  RESULTS_SEARCH_NOT_SAVED: "(nicht gespeichert)",
  RESULTS_SELECT_COLUMNS: "Spalten auswählen",
  RESULTS_SELECT_COLUMNS_APPLY: "Anwenden",
  RESULTS_SELECT_COLUMNS_VISIBLE: "Sichtbare Spalten",
  RESULTS_SELECT_DEFAULT: "Standard-Einstellungen",
  RESULTS_SETTINGS: "Seite anpassen",
  RESULTS_SIMPLE_SEARCH: "Schnellsuche",
  RESULTS_SIMPLE_SEARCH_FOR: "Schnellsuche nach",
  RESULTS_TOMANY_SELECTION: "Es sind zu viele Kontakte ausgewählt, bitte wählen Sie maximal {0} Kontakte aus.",
  RESULTS_TOMANY_SELECTION_TITLE: "Zu viele Kontakte",
  RIGHTSPANEL_BT_SAVE_OTHERS: "({0} Benutzer ausgewählt)",
  RIGHTSPANEL_CURRENT_CHANGED_ALERT: "Die Rechte des aktuell eingeloggten Benutzers wurden geändert. Einige Einstellungen sind unter Umständen erst nach einem Neustart des CRM sichtbar.",
  RIGHTSPANEL_LOAD_UNSAVED_ALERT_TEXT: "Beim Laden einer Konfiguration werden ihre ungespeicherten Änderungen an der Rechte-Konfiguration verworfen. Möchten Sie die aktuelle Konfiguration verwerfen?",
  RIGHTSPANEL_RIGHTS_LOAD: "Konfiguration laden (optional)",
  RIGHTSPANEL_RIGHTS_LOAD_PRESET: "aus Standardvorgaben",
  RIGHTSPANEL_RIGHTS_LOAD_PRESET_POPUP: "Standardvorgabe wählen",
  RIGHTSPANEL_RIGHTS_LOAD_USER: "von Benutzer",
  RIGHTSPANEL_RIGHTS_LOAD_USER_POPUP: "Benutzer wählen",
  RIGHTSPANEL_RIGHTS_NUM: "({0} von {1} Rechten ausgewählt)",
  RIGHTSPANEL_RIGHTS_SAVE_SUBTITLE: "für folgende Benutzer",
  RIGHTSPANEL_RIGHTS_SAVE_TITLE: "Konfiguration speichern",
  RIGHTSPANEL_RIGHTS_SELECTED: "Rechte-Konfiguration",
  RIGHTSPANEL_RIGHTS_SELECTED_HINT: "(Liste anklicken zum Bearbeiten)",
  RIGHTSPANEL_SAVE_OTHERS_ALERT: "Wollen Sie die gewählten Berechtigungen für {0} Nutzer speichern?",
  RIGHTSPANEL_SAVE_OTHERS_ALERT_TITLE: "Berechtigungen bestätigen",
  RIGHTSPANEL_TITLE: "Berechtigungen konfigurieren",
  RIGHTSPANEL_USERLIST_ALERT_BTN_KEEP: "Erhalten",
  RIGHTSPANEL_USERLIST_ALERT_TEXT: "Sie haben im Bereich 'Konfiguration speichern' mehrere Benutzer ausgewählt. Wollen Sie diese Auswahl verwerfen oder erhalten?",
  RIGHTSPANEL_USERLIST_ALERT_TITLE: "Gewählte Benutzer",
  RIGHTSPANEL_USER_ADMIN_TT: "Dieser Benutzer ist ein Administrator",
  RIGHT_GROUP_CAMPAIGN_DESC: "",
  RIGHT_GROUP_CAMPAIGN_NAME: "Kampagnen",
  RIGHT_GROUP_CAMPAIGN_TREE_DESC: "",
  RIGHT_GROUP_CAMPAIGN_TREE_NAME: "Kampagnen-Menü",
  RIGHT_GROUP_CONTACT_DESC: "",
  RIGHT_GROUP_CONTACT_NAME: "Kontakte",
  RIGHT_GROUP_DASHBOARD_DESC: "",
  RIGHT_GROUP_DASHBOARD_NAME: "Dashboard",
  RIGHT_GROUP_MAILING_DESC: "",
  RIGHT_GROUP_MAILING_NAME: "Mailings",
  RIGHT_GROUP_MULTI_DESC: "",
  RIGHT_GROUP_MULTI_NAME: "Massenänderungen",
  RIGHT_GROUP_NOTE_DESC: "",
  RIGHT_GROUP_NOTE_NAME: "Bemerkungen",
  RIGHT_GROUP_OTHER_DESC: "",
  RIGHT_GROUP_OTHER_NAME: "Verwaltung",
  RIGHT_GROUP_PRINT_MAIL_DESC: "",
  RIGHT_GROUP_PRINT_MAIL_NAME: "Print Mailings",
  RIGHT_GROUP_RESUBMISSION_DESC: "",
  RIGHT_GROUP_RESUBMISSION_NAME: "Wiedervorlagen",
  RIGHT_GROUP_SEARCH_DESC: "",
  RIGHT_GROUP_SEARCH_NAME: "Suchen und Kontaktgruppen",
  RIGHT_GROUP_SEARCH_TREE_DESC: "",
  RIGHT_GROUP_SEARCH_TREE_NAME: "Personen-Menü",
  RIGHT_PRESET_ALL: "Vollzugriff",
  RIGHT_PRESET_ANALYSIS: "Analyse",
  RIGHT_PRESET_DATAENTRY: "Nacherfassung",
  RIGHT_PRESET_NONE: "Minimalzugriff",
  RIGHT_VAR_ADMIN_CONTACT_EDIT_DESC: "",
  RIGHT_VAR_ADMIN_CONTACT_EDIT_NAME: "Verwaltung: Kontaktreiter bearbeiten",
  RIGHT_VAR_ADMIN_COUNTRYFIX_EDIT_DESC: "",
  RIGHT_VAR_ADMIN_COUNTRYFIX_EDIT_NAME: "Verwaltung: Länderkorrektur",
  RIGHT_VAR_ADMIN_EDIT_LOAD_DESC: "",
  RIGHT_VAR_ADMIN_EDIT_LOAD_NAME: "Verwaltung: @it Funktionen",
  RIGHT_VAR_CAMPAIGN_CREATE_DESC: "",
  RIGHT_VAR_CAMPAIGN_CREATE_NAME: "Kampagnen: neu anlegen",
  RIGHT_VAR_CAMPAIGN_DELETE_DESC: "",
  RIGHT_VAR_CAMPAIGN_DELETE_NAME: "Kampagnen: löschen",
  RIGHT_VAR_CAMPAIGN_EDIT_DESC: "",
  RIGHT_VAR_CAMPAIGN_EDIT_NAME: "Kampagnen: bearbeiten",
  RIGHT_VAR_CAMPAIGN_TOP_LEVEL_CREATE_DESC: "benötigt 'Kampagnen: neu anlegen'",
  RIGHT_VAR_CAMPAIGN_TOP_LEVEL_CREATE_NAME: "Kampagnen: neu auf oberster Ebene anlegen",
  RIGHT_VAR_CAMPAIGN_TREE_SEE_DESC: "Zeigt das Kampagnen-Menü an. Die Berechtigungen für die darin enthaltenen Menüpunkte müssen extra erteilt werden. ",
  RIGHT_VAR_CAMPAIGN_TREE_SEE_NAME: "Kampagnen-Menü: Menü anzeigen",
  RIGHT_VAR_CATEGORY_CREATE_DESC: "",
  RIGHT_VAR_CATEGORY_CREATE_NAME: "Kategorien: Neue Kategorie hinzufügen",
  RIGHT_VAR_CONTACT_CREATE_DESC: "",
  RIGHT_VAR_CONTACT_CREATE_NAME: "Kontakte: neu anlegen",
  RIGHT_VAR_CONTACT_DELETE_DESC: "",
  RIGHT_VAR_CONTACT_DELETE_NAME: "Kontakte: löschen",
  RIGHT_VAR_CONTACT_EDIT_DESC: "",
  RIGHT_VAR_CONTACT_EDIT_NAME: "Kontakte: bearbeiten",
  RIGHT_VAR_DASHBOARD_CAMPAIGN_SEE_DESC: "",
  RIGHT_VAR_DASHBOARD_CAMPAIGN_SEE_NAME: "Dashboard: 'Kampagnen' sehen",
  RIGHT_VAR_DASHBOARD_MAILING_SEE_DESC: "",
  RIGHT_VAR_DASHBOARD_MAILING_SEE_NAME: "Dashboard: 'Mailings' sehen",
  RIGHT_VAR_DASHBOARD_REPORTING_SEE_DESC: "",
  RIGHT_VAR_DASHBOARD_REPORTING_SEE_NAME: "Dashboard: 'Reporting' sehen",
  RIGHT_VAR_FOLDER_CAMPAIGN_CREATE_DESC: "",
  RIGHT_VAR_FOLDER_CAMPAIGN_CREATE_NAME: "Kampagnen-Menü: Ordner neu anlegen",
  RIGHT_VAR_FOLDER_CAMPAIGN_DELETE_DESC: "",
  RIGHT_VAR_FOLDER_CAMPAIGN_DELETE_NAME: "Kampagnen-Menü: Ordner löschen",
  RIGHT_VAR_FOLDER_CAMPAIGN_EDIT_DESC: "",
  RIGHT_VAR_FOLDER_CAMPAIGN_EDIT_NAME: "Kampagnen-Menü: Ordner bearbeiten",
  RIGHT_VAR_FOLDER_CAMPAIGN_TOP_LEVEL_CREATE_DESC: "benötigt 'Kampagnen-Menü: Ordner neu anlegen'",
  RIGHT_VAR_FOLDER_CAMPAIGN_TOP_LEVEL_CREATE_NAME: "Kampagnen-Menü: Ordner neu auf oberster Ebene anlegen",
  RIGHT_VAR_FOLDER_SEARCH_CREATE_DESC: "",
  RIGHT_VAR_FOLDER_SEARCH_CREATE_NAME: "Personen-Menü: Ordner neu anlegen",
  RIGHT_VAR_FOLDER_SEARCH_DELETE_DESC: "",
  RIGHT_VAR_FOLDER_SEARCH_DELETE_NAME: "Personen-Menü: Ordner löschen",
  RIGHT_VAR_FOLDER_SEARCH_EDIT_DESC: "",
  RIGHT_VAR_FOLDER_SEARCH_EDIT_NAME: "Personen-Menü: Ordner bearbeiten",
  RIGHT_VAR_MAILING_APPROVE_DESC: "",
  RIGHT_VAR_MAILING_APPROVE_NAME: "Mailings: Versand freigeben",
  RIGHT_VAR_MAILING_CREATE_DESC: "",
  RIGHT_VAR_MAILING_CREATE_NAME: "Mailings: neu anlegen",
  RIGHT_VAR_MAILING_DELETE_DESC: "",
  RIGHT_VAR_MAILING_DELETE_NAME: "Mailings: löschen",
  RIGHT_VAR_MAILING_EDIT_DESC: "",
  RIGHT_VAR_MAILING_EDIT_NAME: "Mailings: bearbeiten",
  RIGHT_VAR_MAILING_PREVIEW_SEE_DESC: "",
  RIGHT_VAR_MAILING_PREVIEW_SEE_NAME: "Mailings: Preview Versand",
  RIGHT_VAR_MAILING_REVOKE_DESC: "",
  RIGHT_VAR_MAILING_REVOKE_NAME: "Mailings: Freigabe widerrufen",
  RIGHT_VAR_MAILING_STATISTICS_SEE_DESC: "",
  RIGHT_VAR_MAILING_STATISTICS_SEE_NAME: "Mailings: Statistik anzeigen",
  RIGHT_VAR_MAILING_TOP_LEVEL_CREATE_DESC: "benötigt 'Mailings: neu anlegen'",
  RIGHT_VAR_MAILING_TOP_LEVEL_CREATE_NAME: "Mailings: neu auf oberster Ebene anlegen",
  RIGHT_VAR_MULTI_DELETE_DESC: "benötigt 'Kontakte: löschen'",
  RIGHT_VAR_MULTI_DELETE_NAME: "Massenänderungen: Kontakte löschen",
  RIGHT_VAR_MULTI_EDIT_DESC: "benötigt 'Kontakte: bearbeiten'",
  RIGHT_VAR_MULTI_EDIT_NAME: "Massenänderungen: Kontakte bearbeiten",
  RIGHT_VAR_MULTI_EXPORT_DESC: "",
  RIGHT_VAR_MULTI_EXPORT_NAME: "Massenaktion: Kontakte exportieren",
  RIGHT_VAR_MULTI_MERGE_DESC: "benötigt 'Massenänderungen: Kontakte bearbeiten' und 'Massenänderungen: Kontakte löschen'",
  RIGHT_VAR_MULTI_MERGE_NAME: "Massenänderungen: Dubletten abgleichen",
  RIGHT_VAR_NOTE_CREATE_DESC: "",
  RIGHT_VAR_NOTE_CREATE_NAME: "Bemerkungen: neu anlegen",
  RIGHT_VAR_NOTE_EDIT_DESC: "",
  RIGHT_VAR_NOTE_EDIT_NAME: "Bemerkungen: bearbeiten",
  RIGHT_VAR_PRINT_MAIL_CREATE_DESC: "",
  RIGHT_VAR_PRINT_MAIL_CREATE_NAME: "Print Mailings: neu anlegen",
  RIGHT_VAR_PRINT_MAIL_DELETE_DESC: "",
  RIGHT_VAR_PRINT_MAIL_DELETE_NAME: "Print Mailings: löschen",
  RIGHT_VAR_PRINT_MAIL_EDIT_DESC: "",
  RIGHT_VAR_PRINT_MAIL_EDIT_NAME: "Print Mailings: bearbeiten",
  RIGHT_VAR_PRINT_MAIL_TOP_LEVEL_CREATE_DESC: "benötigt 'Print Mailings: neu anlegen'",
  RIGHT_VAR_PRINT_MAIL_TOP_LEVEL_CREATE_NAME: "Print Mailings: neu auf oberster Ebene anlegen",
  RIGHT_VAR_RESUBMISSION_OTHER_EDIT_DESC: "benötigt 'Wiedervorlagen: eigene anlegen und bearbeiten'",
  RIGHT_VAR_RESUBMISSION_OTHER_EDIT_NAME: "Wiedervorlagen: für andere Benutzer anlegen",
  RIGHT_VAR_RESUBMISSION_OTHER_SEE_DESC: "",
  RIGHT_VAR_RESUBMISSION_OTHER_SEE_NAME: "Wiedervorlagen: von anderen Benutzern auflisten (Dashboard)",
  RIGHT_VAR_RESUBMISSION_SELF_EDIT_DESC: "",
  RIGHT_VAR_RESUBMISSION_SELF_EDIT_NAME: "Wiedervorlagen: eigene anlegen und bearbeiten",
  RIGHT_VAR_SEARCH_CREATE_DESC: "",
  RIGHT_VAR_SEARCH_CREATE_NAME: "Suchen: neu anlegen",
  RIGHT_VAR_SEARCH_DELETE_DESC: "",
  RIGHT_VAR_SEARCH_DELETE_NAME: "Suchen: löschen",
  RIGHT_VAR_SEARCH_EDIT_DESC: "",
  RIGHT_VAR_SEARCH_EDIT_NAME: "Suchen: bearbeiten",
  RIGHT_VAR_TREE_CAMPAIGN_MOVE_DESC: "",
  RIGHT_VAR_TREE_CAMPAIGN_MOVE_NAME: "Kampagnen-Menü: Objekt verschieben",
  RIGHT_VAR_TREE_SEARCH_MOVE_DESC: "",
  RIGHT_VAR_TREE_SEARCH_MOVE_NAME: "Personen-Menü: Objekt verschieben",
  SETTINGS_CONTACTS_ALL_SELECTED_HINT: "Alle Felder wurden ausgewählt",
  SETTINGS_CONTACTS_NO_SELECTED_HINT: "Wählen Sie mindestens ein Feld aus, das angezeigt werden soll.",
  SETTINGS_CONTACTS_NUM_SELECTED: "Ausgewählt: {0}",
  SETTINGS_CONTACTS_SECTION: "Kontakte",
  SETTINGS_GENERAL_SECTION: "Allgemeines",
  SETTINGS_OTHER_SECTION: "Sonstiges",
  SETTINGS_RESET_DEFAULT_TT: "Zurücksetzen auf die Standardeinstellungen",
  SETTINGS_SAVE: "Einstellungen speichern",
  SETTINGS_TITLE: "Einstellungen",
  SAVEAS_DIALOG_CAMPAIGN: "Kampagne",
  SAVEAS_DIALOG_CAMPAIGN_DD_NONE: "[keine]",
  SAVEAS_DIALOG_CANCEL: "Abbrechen",
  SAVEAS_DIALOG_NAME: "Name",
  SAVEAS_DIALOG_NAME_EXISTS: "Dieser Name wird bereits verwendet",
  SAVEAS_DIALOG_NAME_TT: "Hier den zu speichernden Namen eingeben",
  SAVEAS_DIALOG_SAME_NAME: "Dies ist der aktuelle Name",
  SAVEAS_DIALOG_SAVE: "Speichern",
  SAVEAS_DIALOG_SAVE_TT: "Ein neuer Datensatz wird unter dem angebenen Namen erstellt",
  TEMPLATE_GUIDE_CLIPBOARD_OK_SB: "Der Platzhalter wurde in die Zwischenablage kopiert",
  TEMPLATE_GUIDE_CLIPBOARD_ERROR_SB: "!!!Can not copy placeholder",
  TEMPLATE_GUIDE_CURRENT_DATE: "Aktuelles Datum",
  TEMPLATE_GUIDE_FOOTER: "Klicken Sie auf das gewünschte Feld, um dessen Platzhalter-Code in die Zwischenablage zu kopieren. Sie können ihn dann mit Strg+V in den Template-Text einfügen.",
  TEMPLATE_GUIDE_ID: "Personen ID (intern)",
  TEMPLATE_GUIDE_LOGINNAME: "Loginname",
  TEMPLATE_GUIDE_SPECIAL_FIELDS: "Spezielle Felder",
  TEMPLATE_GUIDE_TAGLINE: "Liste der Felder, die in ein Mail-Template eingefügt werden können:",
  TEMPLATE_GUIDE_TITLE: "Platzhalter",
  TEMPLATE_GUIDE_UNSUBSCRIBE_LINK: "Abmeldelink",
  TEMPLATE_GUIDE_WEBVIEW: "Link zur Webansicht des Mailings",
  TEMPLATE_SEARCH_BTN_NO_TEMPLATE: "Keine Vorlage auswählen",
  TEMPLATE_SEARCH_HEAD: "Mail-Vorlagen Suche",
  TEMPLATE_SEARCH_LABEL: "Titel der Vorlage enthält",
  TEMPLATE_SEARCH_LANG: "Sprache der Vorlage",
  TEMPLATE_SEARCH_OFFLINE: "@it Objekt ist offline",
  TEMPLATE_SEARCH_ONLINE: "@it Objekt ist online",
  TEMPLATE_SEARCH_RESULTS_MANY: "{0} Objekte gefunden.",
  TEMPLATE_SEARCH_RESULTS_ONE: "1 Objekt gefunden.",
  TEMPLATE_SEARCH_RESULTS_TOOMANY: "{0}+ Objekte gefunden. Bitte verfeinern Sie Ihre Suche.",
  TEMPLATE_SEARCH_RESULTS_TOOMANY_2: "{0} Vorlagen gefunden, nur die ersten {1} werden angezeigt. Schränken Sie Ihre Suche ein.",
  TEMPLATE_SEARCH_SEARCH: "Suchen",
  TESTMAIL_CLEAR_INPUT: "Eingaben zurücksetzen",
  TESTMAIL_CONFIRM: "Diese Aktion wird ein Preview dieses Mailings an {0} Adressaten versenden. Möchten Sie fortfahren?",
  TESTMAIL_CONFIRM_TITLE: "Preview Versand bestätigen",
  TESTMAIL_DD_PROMPT: "Drag&Drop aus 'Personen'",
  TESTMAIL_DISPATCHING: "Mailing wird versendet...",
  TESTMAIL_DISPATCH_CONFIRMATION: "Versandbestätigung",
  TESTMAIL_DRAG_SEARCH_TT: "Ziehen Sie eine Suche oder Kontaktgruppe aus der Navigationsleiste in dieses Feld.",
  TESTMAIL_HEADER: "Preview Versand",
  TESTMAIL_HINT_PITFALLS: "Bitte beachten Sie, dass E-Mails nur an Kontakte versendet werden, welche die Option 'E-Mail aktiviert' gesetzt haben und nicht als 'Bounced' markiert sind.",
  TESTMAIL_HINT_SAVED_SEARCH: "Ziehen Sie eine gespeicherte Suche oder Kontaktgruppe aus der linken Navigationsspalte in das Feld 'An Auswahl'. Die Anzahl der Adressaten wird automatisch berechnet.",
  TESTMAIL_HINT_SEARCH: "!!!Type a search or contact group name from the People list into the field 'To selection'. The number of recipients will be calculated automatically.",
  TESTMAIL_HINT_TYPE_EMAIL: "1. Wählen Sie einen Musteradressaten aus dem Datenbestand, um die Platzhalter im Mailing-Template mit den Daten dieser Person zu befüllen.\n2. Geben Sie in das Feld 'An E-Mail' eine oder mehrere mit Komma getrennte E-Mail-Adressen ein.",
  TESTMAIL_INPUT_MISSING: "Eingaben unvollständig.",
  TESTMAIL_MAILING_FAILED: "Der Versand ist fehlgeschlagen.",
  TESTMAIL_MAILS_SENT: "E-Mails versendet",
  TESTMAIL_MAIL_SENT: "E-Mail versendet",
  TESTMAIL_PREVIEW_CONTACT: "Musteradressat",
  TESTMAIL_PREVIEW_PREFIX: "Betreff mit 'Preview'-Präfix",
  TESTMAIL_SEND: "Senden",
  TESTMAIL_TOO_MANY_RECIPIENTS: "Über den Preview Versand dürfen maximal {0} Adressaten angeschrieben werden. Bitte verwenden Sie eine andere Kontaktauswahl.",
  TESTMAIL_TOO_MANY_RECIPIENTS_TITLE: "Zu viele Adressaten",
  TESTMAIL_TO_EMAIL: "An E-Mail",
  TESTMAIL_TO_SEARCH: "An Auswahl",
  TESTMAIL_WIZARD_ANY_ADDRESS: "Beliebige Email-Adressen",
  TESTMAIL_WIZARD_CONTACTS: "Kontakte im CRM",
  TESTMAIL_WIZARD_CONTACT_GROUP: "Gespeicherte Kontaktgruppe",
  TESTMAIL_WIZARD_QUESTION: "An wen möchten Sie ein Preview dieses Mailings senden?",
  TESTMAIL_WIZARD_SAVED_SEARCH: "Gespeicherte Suche",
  TESTMAIL_WIZARD_TO_MYSELF: "An mich selbst",
  TESTMAIL_WIZARD_TYPE_EMAILS: "Adresse(n) eingeben",
  TESTMAIL_ZERO_RECIPIENTS: "Die ausgewählte Suche liefert keine Ergebnisse, d.h. es gibt keine Adressaten.",
  TESTMAIL_ZERO_RECIPIENTS_TITLE: "Keine Adressaten",
  TOOLBAR_MENU_HOME: "Home",
  TOOLBAR_MENU_DASHBOARD: "Dashboard",
  TOOLBAR_MENU_MAILINGS: "Mailings",
  TOOLBAR_MENU_SETTINGS: "Einstellungen",
  TOOLBAR_MENU_QUIT_SESSION: "Sitzung beenden",
  WIDGET_CORE_BTN_CONFIG_TT: "Widget konfigurieren",
  WIDGET_CORE_BTN_DASH_ADD_TT: "Widget hinzufügen",
  WIDGET_CORE_BTN_DASH_CONFIG_TT: "Mein Dashboard konfigurieren",
  WIDGET_CORE_BTN_DASH_DONE_TT: "Fertig",
  WIDGET_CORE_BTN_DASH_MULTI_TT: "Mehrere Dashboards verwalten",
  WIDGET_CORE_BTN_DEFAULT_CONFIG: "Standard-Konfiguration",
  WIDGET_CORE_BTN_MOVE_TT: "Ziehen, um Widget zu verschieben",
  WIDGET_CORE_BTN_REMOVE_TT: "Widget von Dashboard entfernen",
  WIDGET_CORE_BTN_RESIZE_TT: "Ziehen, um Größe des Widgets anzupassen",
  WIDGET_CORE_BTN_TIDY_OUTSIDE: "Verdeckte Widgets entfernen",
  WIDGET_CORE_CONFIG_POPUP_TITLE: "Widget konfigurieren",
  WIDGET_CORE_DELETE_ALERT: "Das Widget '{0}' wird von Ihrem persönlichen Dashboard gelöscht.",
  WIDGET_CORE_HINT_ADD: "Fügen Sie individuell Widgets hinzu, indem Sie auf das Plus-Symbol klicken.",
  WIDGET_CORE_HINT_ADD_DEFAULT: "Alternativ können Sie auf den Knopf unten klicken, um zur Standard-Konfiguration zurückzukehren.",
  WIDGET_CORE_HINT_CONFIG: "Dieses Dashboard ist leer. Konfigurieren Sie es, indem Sie oben rechts auf das Zahnrad-Symbol klicken.",
  WIDGET_CORE_HINT_WIDGETS_OUTSIDE: "Einige Widgets sind außerhalb des sichtbaren Bereichs platziert. Klicken Sie den Knopf unten, um diese vom Dashboard zu entfernen.",
  WIDGET_CORE_LIMIT_TT: "Kein weiteres Widget des Typs '{0}' kann mehr platziert werden",
  WIDGET_CORE_MOVE_DELETE_TT: "Widget von Dashboard entfernen",
  WIDGET_CORE_MOVE_PLACE_TT: "Ziehen, um Widget zu platzieren",
  WIDGET_CORE_MULTICONFIG_ADD_BOARD: "Neues Dashboard hinzufügen",
  WIDGET_CORE_MULTICONFIG_DELETE_ALERT: "Möchten Sie diese Dashboard-Konfiguration wirklich löschen?",
  WIDGET_CORE_MULTICONFIG_DELETE_TT: "Dashboard löschen",
  WIDGET_CORE_MULTICONFIG_HINT: "Hier können Sie ihre persönlichen Dashboards umbenennen, löschen oder per Drag&Drop die Reihenfolge ändern.",
  WIDGET_CORE_MULTICONFIG_MAX_HINT: "Es können maximal {0} Dashboards angelegt werden.",
  WIDGET_CORE_MULTICONFIG_UNNAMED: "[Unbenanntes Dashboard]",
  WIDGET_CORE_TIDY_ALERT: "Achtung: Es werden auch Widgets entfernt, die nur teilweise verdeckt sind. Anzahl betroffener Widgets: {0}",
  WIDGET_INFO_MAILDISP_DESC: "Zeigt den Fortschritt eines laufenden Mailing-Versands an. Falls kein Versand läuft, wird alternativ der nächste und letzte Versand angezeigt.",
  WIDGET_INFO_MAILDISP_NAME: "Versandstatus",
  WIDGET_INFO_POSTIT_DESC: "Schreiben Sie eine Notiz auf Ihr Dashboard.",
  WIDGET_INFO_POSTIT_NAME: "Notizzettel",
  WIDGET_INFO_REPORT_DESC: "Zeigt einen gespeicherten Report in Miniaturformat an.",
  WIDGET_INFO_REPORT_NAME: "Mini-Report",
  WIDGET_INFO_RESUB_DESC: "Zeigt eine Liste aller Wiedervorlagen an. Ermöglicht auch die Erstellung von freien Wiedervorlagen (ohne Bindung an einen bestimmten Kontakt).",
  WIDGET_INFO_RESUB_NAME: "Wiedervorlagen",
  WIDGET_MAILDISP_INIT: "Der Versandstatus wird aktualisiert...",
  WIDGET_MAILDISP_NO_PREVIOUS: "Es wurde noch kein Mailing versendet.",
  WIDGET_MAILDISP_NO_UPCOMING: "Es ist momentan kein Versand freigegeben.",
  WIDGET_MAILDISP_PREVIOUS_TT: "Letzter Versand",
  WIDGET_MAILDISP_TITLE: "Versandstatus",
  WIDGET_MAILDISP_UPCOMING_TT: "Nächster Versand",
  WIDGET_POSTIT_EDIT_TT: "Klicken Sie einmal außerhalb des Notizzettels um die Texteingabe zu beenden",
  WIDGET_POSTIT_MAIN_TT: "Doppelklick, um den Text zu bearbeiten",
  WIDGET_REPORT_CHOOSE_REPORT: "[Gespeicherten Report wählen...]",
  WIDGET_REPORT_NOT_CONFIGURED: "Report nicht konfiguriert",
  WIDGET_REPORT_OPTIONS: "Anzeige-Optionen",
  WIDGET_REPORT_OPTION_BARCOLOR: "Balkenfarbe (für Säulen- und Balkendiagramme)",
  WIDGET_REPORT_TEMPLATE: "Report-Vorlage",
  WIDGET_REPORT_WARN_NO_REPORTS: "Sie haben noch keine gespeicherten Reports angelegt. Gehen Sie auf das Reporting Dashboard, um einen Report zu konfigurieren und als Vorlage abzuspeichern.",
  WIDGET_REPORT_WARN_OLD_TITLE: "Der gespeicherte Report, der diesem Widget als Vorlage dient, wurde umbenannt oder gelöscht. Bitte korrigieren Sie die Konfiguration.",
  WIDGET_RESUB_CHK_SHOW_DONE: "Erledigte Einträge anzeigen",
  WIDGET_RESUB_EMPTY_LIST: "Keine Wiedervorlagen",
  WIDGET_RESUB_LIST_SHOW_ALL: "[Alle Wiedervorlagen]",
  WIDGET_RESUB_TITLE: "Wiedervorlagen",
  NO_DATA: "Im angegebenen Zeitraum wurden keine Daten erhoben.",
}

export default de
